<template>
	<div>		
		<!-- <ToolBar v-on:select="handleSelectJT"></ToolBar> -->
        <h3>颜色监控</h3>
		<div class="monitor_section">			
			<device-color-status :jt_id="jt_id" :jt_status="jt_status"  />
		</div>
	</div>
</template>

<script>
	import { workshopRequest } from '@/network/requests/workshop'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	import { jtStatusRequest, jtStatusEnum } from '@/network/requests/jtStatus'
	import { jobOrderRequest } from '@/network/requests/jobOrder'
	import VeLine from 'v-charts/lib/line.common'
	import DeviceColorStatus from '../public/DeviceColorStatus'
	import ToolBar from './ToolBar'
	export default {
        props:[
			'jt_id',
			 'jt_status'
			],

		components: {
			DeviceColorStatus,			
		},
		data() {
			return {
				num: 0,
				workshopId: '',
				workshops: [],
				jt_list: [],				
				selectedJT: {},
			}
		},
		methods: {		
		},
		created() {
			workshopRequest.queryAll().then(res => {
				console.log('获取车间', res)
				this.workshops = res
			})
		},
	}
</script>

<style scoped></style>
